export default __webpack_public_path__ + "static/media/mu.46078ae5.jpg";